import {useQuery, gql} from '@apollo/client'

const clientDetails = gql`
  query clientsdetails {
    clientList {
      CLIENT_ID
      CLIENT_NAME
      TOTAL_ACTIVE_USERS
      TOTAL_GROUPS
      LAST_UPDATED_DATE_TIME
    }
  }
`

export function useGetClientDetails() {
  const {
    data: clientData,
    loading: loadingClients,
    error,
    refetch
  } = useQuery(clientDetails, {
    context: {clientName: 'adminPanel'},
    notifyOnNetworkStatusChange: true
  })
  return {clientData, loadingClients, error, refetch}
}
